export default "__VITE_ASSET__DZWdUfch__"